"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkipRouter = exports.SKIP_API_URL = void 0;
const amino_1 = require("@cosmjs/amino");
const cosmwasm_stargate_1 = require("@cosmjs/cosmwasm-stargate");
const encoding_1 = require("@cosmjs/encoding");
const math_1 = require("@cosmjs/math");
const proto_signing_1 = require("@cosmjs/proto-signing");
const proto_signing_2 = require("@cosmjs/proto-signing");
const stargate_1 = require("@cosmjs/stargate");
const rest_1 = require("@injectivelabs/sdk-ts/dist/cjs/client/chain/rest");
const utils_1 = require("@injectivelabs/utils");
const axios_1 = __importDefault(require("axios"));
const signing_1 = require("cosmjs-types/cosmos/tx/signing/v1beta1/signing");
const tx_1 = require("cosmjs-types/cosmos/tx/v1beta1/tx");
const tx_2 = require("cosmjs-types/cosmwasm/wasm/v1/tx");
const viem_1 = require("viem");
const chains_1 = __importDefault(require("./chains"));
const abis_1 = require("./constants/abis");
const injective_1 = require("./injective");
const request_client_1 = require("./request-client");
const transactions_1 = require("./transactions");
const types_1 = require("./types");
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
exports.SKIP_API_URL = "https://api.skip.money";
class SkipRouter {
    constructor(options = {}) {
        var _a, _b;
        this.requestClient = new request_client_1.RequestClient((_a = options.apiURL) !== null && _a !== void 0 ? _a : exports.SKIP_API_URL);
        this.aminoTypes = new stargate_1.AminoTypes(Object.assign(Object.assign({}, (0, stargate_1.createDefaultAminoConverters)()), (0, cosmwasm_stargate_1.createWasmAminoConverters)()));
        this.registry = new proto_signing_1.Registry(stargate_1.defaultRegistryTypes);
        this.registry.register("/cosmwasm.wasm.v1.MsgExecuteContract", tx_2.MsgExecuteContract);
        this.endpointOptions = (_b = options.endpointOptions) !== null && _b !== void 0 ? _b : {};
        this.getCosmosSigner = options.getCosmosSigner;
        this.getEVMSigner = options.getEVMSigner;
    }
    assets(options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.get("/v1/fungible/assets", (0, types_1.assetsRequestToJSON)(options));
            return Object.entries(response.chain_to_assets_map).reduce((acc, [chainID, { assets }]) => {
                acc[chainID] = assets.map((asset) => (0, types_1.assetFromJSON)(asset));
                return acc;
            }, {});
        });
    }
    assetsFromSource(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.post("/v1/fungible/assets_from_source", (0, types_1.assetsFromSourceRequestToJSON)(options));
            return Object.entries(response.dest_assets).reduce((acc, [chainID, { assets }]) => {
                acc[chainID] = assets.map((asset) => (0, types_1.assetFromJSON)(asset));
                return acc;
            }, {});
        });
    }
    chains({ includeEVM, } = { includeEVM: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.get("/v1/info/chains", {
                include_evm: includeEVM,
            });
            return response.chains.map((chain) => (0, types_1.chainFromJSON)(chain));
        });
    }
    executeRoute(options) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const { route, userAddresses, validateGasBalance } = options;
            const messages = yield this.messages({
                sourceAssetDenom: route.sourceAssetDenom,
                sourceAssetChainID: route.sourceAssetChainID,
                destAssetDenom: route.destAssetDenom,
                destAssetChainID: route.destAssetChainID,
                amountIn: route.amountIn,
                amountOut: (_a = route.estimatedAmountOut) !== null && _a !== void 0 ? _a : "0",
                addressList: route.chainIDs.map((chainID) => userAddresses[chainID]),
                operations: route.operations,
                slippageTolerancePercent: (_b = options.slippageTolerancePercent) !== null && _b !== void 0 ? _b : "1",
            });
            if (validateGasBalance) {
                // check balances on chains where a tx is initiated
                yield this.validateGasBalances(messages, userAddresses);
            }
            // execute txs
            for (let i = 0; i < messages.length; i++) {
                const message = messages[i];
                if ("multiChainMsg" in message) {
                    const { multiChainMsg } = message;
                    const feeInfo = this.getFeeInfoForChain(multiChainMsg.chainID);
                    let averageGasPrice = 0;
                    if (feeInfo.low_gas_price) {
                        averageGasPrice = feeInfo.low_gas_price;
                    }
                    else if (feeInfo.average_gas_price) {
                        averageGasPrice = feeInfo.average_gas_price;
                    }
                    const feeAmount = averageGasPrice * parseInt((0, transactions_1.getGasAmountForMessage)(multiChainMsg));
                    let getOfflineSigner = this.getCosmosSigner;
                    if (options.getCosmosSigner) {
                        getOfflineSigner = options.getCosmosSigner;
                    }
                    if (!getOfflineSigner) {
                        throw new Error(`Unable to find offline signer for chain ${multiChainMsg.chainID}`);
                    }
                    const signer = yield getOfflineSigner(multiChainMsg.chainID);
                    const tx = yield this.executeMultiChainMessage({
                        signerAddress: userAddresses[multiChainMsg.chainID],
                        signer,
                        message: multiChainMsg,
                        feeAmount: (0, proto_signing_2.coin)(feeAmount, feeInfo.denom),
                    });
                    if (options.onTransactionBroadcast) {
                        yield options.onTransactionBroadcast({
                            chainID: multiChainMsg.chainID,
                            txHash: tx.transactionHash,
                        });
                    }
                    const txStatusResponse = yield this.waitForTransaction({
                        chainID: multiChainMsg.chainID,
                        txHash: tx.transactionHash,
                    });
                    if (options.onTransactionSuccess) {
                        yield options.onTransactionSuccess({
                            chainID: multiChainMsg.chainID,
                            txHash: tx.transactionHash,
                            success: txStatusResponse.status === "STATE_COMPLETED_SUCCESS",
                        });
                    }
                }
                if ("evmTx" in message) {
                    const { evmTx } = message;
                    let getEVMSigner = this.getEVMSigner;
                    if (options.getEVMSigner) {
                        getEVMSigner = options.getEVMSigner;
                    }
                    if (!getEVMSigner) {
                        throw new Error("Unable to get EVM signer");
                    }
                    const evmSigner = yield getEVMSigner(evmTx.chainID);
                    const txReceipt = yield this.executeEVMTransaction({
                        message: evmTx,
                        signer: evmSigner,
                    });
                    if (options.onTransactionBroadcast) {
                        yield options.onTransactionBroadcast({
                            chainID: evmTx.chainID,
                            txHash: txReceipt.transactionHash,
                        });
                    }
                    const txStatusResponse = yield this.waitForTransaction({
                        chainID: evmTx.chainID,
                        txHash: txReceipt.transactionHash,
                    });
                    if (options.onTransactionSuccess) {
                        yield options.onTransactionSuccess({
                            chainID: evmTx.chainID,
                            txHash: txReceipt.transactionHash,
                            success: txStatusResponse.status === "STATE_COMPLETED_SUCCESS",
                        });
                    }
                }
            }
        });
    }
    executeMultiChainMessage(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { signerAddress, signer, message, feeAmount } = options;
            const accounts = yield signer.getAccounts();
            const accountFromSigner = accounts.find((account) => account.address === signerAddress);
            if (!accountFromSigner) {
                throw new Error("Failed to retrieve account from signer");
            }
            const endpoint = yield this.getRpcEndpointForChain(message.chainID);
            const { accountNumber, sequence } = yield this.getAccountNumberAndSequence(signerAddress, message.chainID);
            const gas = (0, transactions_1.getGasAmountForMessage)(message);
            let rawTx;
            if ((0, proto_signing_1.isOfflineDirectSigner)(signer)) {
                rawTx = yield this.signMultiChainMessageDirect({
                    signerAddress,
                    signer,
                    multiChainMessage: message,
                    fee: {
                        amount: [feeAmount],
                        gas,
                    },
                    signerData: {
                        accountNumber,
                        sequence,
                        chainId: message.chainID,
                    },
                });
            }
            else {
                rawTx = yield this.signMultiChainMessageAmino({
                    signerAddress,
                    signer,
                    multiChainMessage: message,
                    fee: {
                        amount: [feeAmount],
                        gas,
                    },
                    signerData: {
                        accountNumber,
                        sequence,
                        chainId: message.chainID,
                    },
                });
            }
            const txBytes = tx_1.TxRaw.encode(rawTx).finish();
            const stargateClient = yield stargate_1.SigningStargateClient.connectWithSigner(endpoint, signer);
            const tx = yield stargateClient.broadcastTx(txBytes);
            return tx;
        });
    }
    executeEVMTransaction({ message, signer, }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!signer.account) {
                throw new Error("Failed to retrieve account from signer");
            }
            const extendedSigner = signer.extend(viem_1.publicActions);
            // check for approvals
            for (const requiredApproval of message.requiredERC20Approvals) {
                const allowance = yield extendedSigner.readContract({
                    address: requiredApproval.tokenContract,
                    abi: abis_1.erc20ABI,
                    functionName: "allowance",
                    args: [
                        signer.account.address,
                        requiredApproval.spender,
                    ],
                });
                if (allowance > BigInt(requiredApproval.amount)) {
                    continue;
                }
                const txHash = yield extendedSigner.writeContract({
                    account: signer.account,
                    address: requiredApproval.tokenContract,
                    abi: abis_1.erc20ABI,
                    functionName: "approve",
                    args: [requiredApproval.spender, viem_1.maxUint256],
                    chain: signer.chain,
                });
                const receipt = yield extendedSigner.waitForTransactionReceipt({
                    hash: txHash,
                });
                if (receipt.status === "reverted") {
                    throw new Error(`EVM tx reverted: ${receipt.transactionHash}`);
                }
            }
            // execute tx
            const txHash = yield extendedSigner.sendTransaction({
                account: signer.account,
                to: message.to,
                data: `0x${message.data}`,
                chain: signer.chain,
                value: message.value === "" ? undefined : BigInt(message.value),
            });
            const receipt = yield extendedSigner.waitForTransactionReceipt({
                hash: txHash,
            });
            return receipt;
        });
    }
    signMultiChainMessageDirect(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { signer, signerAddress, multiChainMessage, fee, signerData: { accountNumber, sequence, chainId }, } = options;
            if (multiChainMessage.chainID.includes("evmos")) {
                return this.signMultiChainMessageDirectEvmos(signerAddress, signer, multiChainMessage, fee, { accountNumber, sequence, chainId });
            }
            if (multiChainMessage.chainID.includes("injective")) {
                return this.signMultiChainMessageDirectInjective(signerAddress, signer, multiChainMessage, fee, { accountNumber, sequence, chainId });
            }
            const accounts = yield signer.getAccounts();
            const accountFromSigner = accounts.find((account) => account.address === signerAddress);
            if (!accountFromSigner) {
                throw new Error("Failed to retrieve account from signer");
            }
            const message = (0, transactions_1.getEncodeObjectFromMultiChainMessage)(multiChainMessage);
            const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
            const txBodyEncodeObject = {
                typeUrl: "/cosmos.tx.v1beta1.TxBody",
                value: {
                    messages: [message],
                },
            };
            const txBodyBytes = this.registry.encode(txBodyEncodeObject);
            const gasLimit = math_1.Int53.fromString(fee.gas).toNumber();
            const authInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence }], fee.amount, gasLimit, fee.granter, fee.payer);
            const signDoc = (0, proto_signing_1.makeSignDoc)(txBodyBytes, authInfoBytes, chainId, accountNumber);
            const { signature, signed } = yield signer.signDirect(signerAddress, signDoc);
            return tx_1.TxRaw.fromPartial({
                bodyBytes: signed.bodyBytes,
                authInfoBytes: signed.authInfoBytes,
                signatures: [(0, encoding_1.fromBase64)(signature.signature)],
            });
        });
    }
    // TODO: This is previously existing code, just moved to a new function.
    // Using signMultiChainMessageDirect on evmos DOES currently fail.
    // I need to investigate what exactly is even different about this and hopefully remove it all together.
    signMultiChainMessageDirectEvmos(signerAddress, signer, multiChainMessage, fee, { accountNumber, sequence, chainId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const accounts = yield signer.getAccounts();
            const accountFromSigner = accounts.find((account) => account.address === signerAddress);
            if (!accountFromSigner) {
                throw new Error("Failed to retrieve account from signer");
            }
            const message = (0, transactions_1.getEncodeObjectFromMultiChainMessageInjective)(multiChainMessage);
            const pk = Buffer.from(accountFromSigner.pubkey).toString("base64");
            const { signDoc } = (0, injective_1.createTransaction)({
                pubKey: pk,
                chainId: chainId,
                message: [message],
                sequence,
                accountNumber,
                timeoutHeight: 0,
                fee,
            });
            const directSignResponse = yield signer.signDirect(signerAddress, 
            // @ts-expect-error TODO: Fix this
            signDoc);
            return tx_1.TxRaw.fromPartial({
                bodyBytes: directSignResponse.signed.bodyBytes,
                authInfoBytes: directSignResponse.signed.authInfoBytes,
                signatures: [(0, encoding_1.fromBase64)(directSignResponse.signature.signature)],
            });
        });
    }
    // TODO: This is previously existing code, just moved to a new function.
    // Using signMultiChainMessageDirect on injective DOES currently fail.
    // I need to investigate what exactly is even different about this and hopefully remove it all together.
    signMultiChainMessageDirectInjective(signerAddress, signer, multiChainMessage, fee, { accountNumber, sequence, chainId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const accounts = yield signer.getAccounts();
            const accountFromSigner = accounts.find((account) => account.address === signerAddress);
            if (!accountFromSigner) {
                throw new Error("Failed to retrieve account from signer");
            }
            const restEndpoint = yield this.getRestEndpointForChain(multiChainMessage.chainID);
            /** Block Details */
            const chainRestTendermintApi = new rest_1.ChainRestTendermintApi(restEndpoint);
            const latestBlock = yield chainRestTendermintApi.fetchLatestBlock();
            const latestHeight = latestBlock.header.height;
            const timeoutHeight = new utils_1.BigNumberInBase(latestHeight).plus(utils_1.DEFAULT_BLOCK_TIMEOUT_HEIGHT);
            const pk = Buffer.from(accountFromSigner.pubkey).toString("base64");
            const message = (0, transactions_1.getEncodeObjectFromMultiChainMessageInjective)(multiChainMessage);
            const { signDoc } = (0, injective_1.createTransaction)({
                pubKey: pk,
                chainId: chainId,
                message: [message],
                sequence,
                accountNumber,
                timeoutHeight: timeoutHeight.toNumber(),
                fee,
            });
            const directSignResponse = yield signer.signDirect(signerAddress, 
            // @ts-expect-error TODO: Fix this
            signDoc);
            return tx_1.TxRaw.fromPartial({
                bodyBytes: directSignResponse.signed.bodyBytes,
                authInfoBytes: directSignResponse.signed.authInfoBytes,
                signatures: [(0, encoding_1.fromBase64)(directSignResponse.signature.signature)],
            });
        });
    }
    signMultiChainMessageAmino(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const { signer, signerAddress, multiChainMessage, fee, signerData: { accountNumber, sequence, chainId }, } = options;
            const accounts = yield signer.getAccounts();
            const accountFromSigner = accounts.find((account) => account.address === signerAddress);
            if (!accountFromSigner) {
                throw new Error("Failed to retrieve account from signer");
            }
            const message = (0, transactions_1.getEncodeObjectFromMultiChainMessage)(multiChainMessage);
            const pubkey = (0, proto_signing_1.encodePubkey)((0, amino_1.encodeSecp256k1Pubkey)(accountFromSigner.pubkey));
            const signMode = signing_1.SignMode.SIGN_MODE_LEGACY_AMINO_JSON;
            const msgs = [this.aminoTypes.toAmino(message)];
            msgs[0].value.memo = message.value.memo;
            const signDoc = (0, amino_1.makeSignDoc)(msgs, fee, chainId, "", accountNumber, sequence);
            const { signature, signed } = yield signer.signAmino(signerAddress, signDoc);
            const signedTxBody = {
                messages: signed.msgs.map((msg) => this.aminoTypes.fromAmino(msg)),
                memo: signed.memo,
            };
            signedTxBody.messages[0].value.memo = message.value.memo;
            const signedTxBodyEncodeObject = {
                typeUrl: "/cosmos.tx.v1beta1.TxBody",
                value: signedTxBody,
            };
            const signedTxBodyBytes = this.registry.encode(signedTxBodyEncodeObject);
            const signedGasLimit = math_1.Int53.fromString(signed.fee.gas).toNumber();
            const signedSequence = math_1.Int53.fromString(signed.sequence).toNumber();
            const signedAuthInfoBytes = (0, proto_signing_1.makeAuthInfoBytes)([{ pubkey, sequence: signedSequence }], signed.fee.amount, signedGasLimit, signed.fee.granter, signed.fee.payer, signMode);
            return tx_1.TxRaw.fromPartial({
                bodyBytes: signedTxBodyBytes,
                authInfoBytes: signedAuthInfoBytes,
                signatures: [(0, encoding_1.fromBase64)(signature.signature)],
            });
        });
    }
    messages(options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.post("/v2/fungible/msgs", Object.assign(Object.assign({}, (0, types_1.msgsRequestToJSON)(options)), { slippage_tolerance_percent: (_a = options.slippageTolerancePercent) !== null && _a !== void 0 ? _a : "0" }));
            return response.msgs.map((msg) => (0, types_1.msgFromJSON)(msg));
        });
    }
    route(options) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.post("/v2/fungible/route", Object.assign(Object.assign({}, (0, types_1.routeRequestToJSON)(options)), { cumulative_affiliate_fee_bps: (_a = options.cumulativeAffiliateFeeBPS) !== null && _a !== void 0 ? _a : "0" }));
            return (0, types_1.routeResponseFromJSON)(response);
        });
    }
    recommendAssets(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.post("/v1/fungible/recommend_assets", (0, types_1.recommendAssetsRequestToJSON)(options));
            return response.recommendations.map((recommendation) => (0, types_1.assetRecommendationFromJSON)(recommendation));
        });
    }
    submitTransaction({ chainID, tx, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.post("/v2/tx/submit", {
                chain_id: chainID,
                tx: tx,
            });
            return (0, types_1.submitTxResponseFromJSON)(response);
        });
    }
    trackTransaction({ chainID, txHash, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.post("/v2/tx/track", {
                chain_id: chainID,
                tx_hash: txHash,
            });
            return (0, types_1.trackTxResponseFromJSON)(response);
        });
    }
    transactionStatus({ chainID, txHash, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.get("/v2/tx/status", {
                chain_id: chainID,
                tx_hash: txHash,
            });
            return (0, types_1.txStatusResponseFromJSON)(response);
        });
    }
    waitForTransaction({ chainID, txHash, }) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.trackTransaction({
                chainID,
                txHash,
            });
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const txStatusResponse = yield this.transactionStatus({
                    chainID,
                    txHash,
                });
                if (txStatusResponse.status === "STATE_COMPLETED") {
                    return txStatusResponse;
                }
                yield wait(1000);
            }
        });
    }
    venues() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.requestClient.get("/v1/fungible/venues");
            return response.venues.map((venue) => (0, types_1.swapVenueFromJSON)(venue));
        });
    }
    getAccountNumberAndSequence(address, chainID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (chainID.includes("evmos")) {
                return this.getAccountNumberAndSequenceEvmos(address, chainID);
            }
            if (chainID.includes("injective")) {
                return this.getAccountNumberAndSequenceInjective(address, chainID);
            }
            const endpoint = yield this.getRpcEndpointForChain(chainID);
            const client = yield stargate_1.StargateClient.connect(endpoint);
            const account = yield client.getAccount(address);
            if (!account) {
                throw new Error("Failed to retrieve account");
            }
            client.disconnect();
            return {
                accountNumber: account.accountNumber,
                sequence: account.sequence,
            };
        });
    }
    getAccountNumberAndSequenceEvmos(address, chainID) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = yield this.getRestEndpointForChain(chainID);
            const response = yield axios_1.default.get(`${endpoint}/cosmos/auth/v1beta1/accounts/${address}`);
            const accountNumber = response.data.account.base_account
                .account_number;
            const sequence = response.data.account.base_account.sequence;
            return {
                accountNumber,
                sequence,
            };
        });
    }
    getAccountNumberAndSequenceInjective(address, chainID) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = yield this.getRestEndpointForChain(chainID);
            const chainRestAuthApi = new rest_1.ChainRestAuthApi(endpoint);
            const accountDetailsResponse = yield chainRestAuthApi.fetchAccount(address);
            return {
                accountNumber: parseInt(accountDetailsResponse.account.base_account.account_number),
                sequence: parseInt(accountDetailsResponse.account.base_account.sequence),
            };
        });
    }
    getRpcEndpointForChain(chainID) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.endpointOptions.getRpcEndpointForChain) {
                return this.endpointOptions.getRpcEndpointForChain(chainID);
            }
            if (this.endpointOptions.endpoints &&
                this.endpointOptions.endpoints[chainID]) {
                const endpointOptions = this.endpointOptions.endpoints[chainID];
                if (endpointOptions.rpc) {
                    return endpointOptions.rpc;
                }
            }
            const chain = (0, chains_1.default)().find((chain) => chain.chain_id === chainID);
            if (!chain) {
                throw new Error(`Failed to find chain with ID ${chainID} in registry`);
            }
            const endpoint = (_b = (_a = chain.apis) === null || _a === void 0 ? void 0 : _a.rpc) === null || _b === void 0 ? void 0 : _b[0].address;
            if (!endpoint) {
                throw new Error(`Failed to find RPC endpoint for chain ${chainID}`);
            }
            return endpoint;
        });
    }
    getRestEndpointForChain(chainID) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.endpointOptions.getRestEndpointForChain) {
                return this.endpointOptions.getRestEndpointForChain(chainID);
            }
            if (this.endpointOptions.endpoints &&
                this.endpointOptions.endpoints[chainID]) {
                const endpointOptions = this.endpointOptions.endpoints[chainID];
                if (endpointOptions.rest) {
                    return endpointOptions.rest;
                }
            }
            const chain = (0, chains_1.default)().find((chain) => chain.chain_id === chainID);
            if (!chain) {
                throw new Error(`Failed to find chain with ID ${chainID} in registry`);
            }
            const endpoint = (_b = (_a = chain.apis) === null || _a === void 0 ? void 0 : _a.rest) === null || _b === void 0 ? void 0 : _b[0].address;
            if (!endpoint) {
                throw new Error(`Failed to find REST endpoint for chain ${chainID}`);
            }
            return endpoint;
        });
    }
    getFeeInfoForChain(chainID) {
        var _a;
        const chain = (0, chains_1.default)().find((chain) => chain.chain_id === chainID);
        if (!chain) {
            throw new Error(`Failed to find chain with ID ${chainID} in registry`);
        }
        const feeInfo = (_a = chain.fees) === null || _a === void 0 ? void 0 : _a.fee_tokens[0];
        if (!feeInfo) {
            throw new Error("No fee info found");
        }
        return feeInfo;
    }
    validateGasBalances(messages, userAddresses) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < messages.length; i++) {
                const message = messages[i];
                if ("multiChainMsg" in message) {
                    yield this.validateCosmosGasBalance(userAddresses[message.multiChainMsg.chainID], message.multiChainMsg);
                }
            }
        });
    }
    validateCosmosGasBalance(signerAddress, message) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = this.getFeeInfoForChain(message.chainID);
            const gasNeeded = (0, transactions_1.getGasAmountForMessage)(message);
            let averageGasPrice = 0;
            if (feeInfo.low_gas_price) {
                averageGasPrice = feeInfo.low_gas_price;
            }
            else if (feeInfo.average_gas_price) {
                averageGasPrice = feeInfo.average_gas_price;
            }
            const amountNeeded = averageGasPrice * parseInt(gasNeeded);
            const endpoint = yield this.getRpcEndpointForChain(message.chainID);
            const stargateClient = yield stargate_1.StargateClient.connect(endpoint);
            const balance = yield stargateClient.getBalance(signerAddress, feeInfo.denom);
            if (parseInt(balance.amount) < amountNeeded) {
                throw new Error(`Insufficient fee token to initiate transfer on ${message.chainID}. Need ${amountNeeded} ${feeInfo.denom}, but only have ${balance.amount} ${feeInfo.denom}.`);
            }
        });
    }
}
exports.SkipRouter = SkipRouter;
//# sourceMappingURL=client.js.map